module.exports = __webpack_public_path__ + "img/组 1117@2x(1).eb1f524c.png";